import { motion } from "framer-motion";
import { Accessibility, Facebook, Mail, MapPin } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";

export default function Footer() {
  return (
    <footer id="visit" className="border-t border-clay-border bg-clay-surface/60">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="lg:col-span-5"
        >
          <div className="flex items-center gap-3 mb-6">
            <img src={LOGO_URL} alt="Mid Western Speedway logo" className="w-11 h-11 object-cover rounded-sm ring-1 ring-clay-border" />
            <span className="font-display font-bold uppercase text-xl tracking-wide">
              Mid Western Speedway <span className="text-clay-orange">Darlington</span>
            </span>
          </div>
          <p className="text-clay-muted leading-relaxed max-w-md">
            Community-driven grassroots speedway since 1968. Camping available on race weekends, canteen and food
            booth on site, and seating for the whole family. Everyone is welcome here.
          </p>
          <div
            data-testid="accessibility-note"
            className="mt-6 flex items-start gap-3 border border-clay-border bg-clay-card/40 px-4 py-3 max-w-md"
          >
            <Accessibility className="w-5 h-5 text-clay-gold shrink-0 mt-0.5" />
            <p className="text-clay-muted text-sm leading-relaxed">
              Please note we currently do not have disabled facilities on site — we're actively working on
              accessibility improvements for future seasons.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="lg:col-span-4"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-clay-orange mb-5">Track Location</p>
          <a
            data-testid="footer-address"
            href="https://maps.google.com/?q=-38.001916,143.048036"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-3 text-clay-text hover:text-clay-gold transition-colors group"
          >
            <MapPin className="w-5 h-5 text-clay-orange shrink-0 mt-0.5" />
            <span>
              2810 Hamilton Hwy
              <br />
              Darlington VIC 3271, Australia
            </span>
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="lg:col-span-3"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-clay-orange mb-5">Contact</p>
          <a
            data-testid="contact-form-submit"
            href="mailto:midwesternspeedway2@gmail.com"
            className="flex items-center gap-3 text-clay-text hover:text-clay-gold transition-colors break-all"
          >
            <Mail className="w-5 h-5 text-clay-orange shrink-0" />
            <span className="text-sm">midwesternspeedway2@gmail.com</span>
          </a>
          <a
            data-testid="footer-facebook-link"
            href="https://www.facebook.com/share/1QZoHB67yq/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-clay-text hover:text-clay-gold transition-colors mt-4"
          >
            <Facebook className="w-5 h-5 text-clay-orange shrink-0" />
            <span className="text-sm">Follow us on Facebook</span>
          </a>
        </motion.div>
      </div>

      <div className="border-t border-clay-border">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-clay-muted">
            © 2026 Mortlake Car Club — Mid Western Speedway Darlington
          </p>
          <a data-testid="footer-admin-link" href="/admin" className="font-mono text-[11px] uppercase tracking-[0.25em] text-clay-muted hover:text-clay-gold transition-colors">
            Club Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
